import React from "react";
import { Routes, BrowserRouter, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/Login";
import LoginVercelPage from "./pages/LoginVercel";
import SignupPage from "./pages/Signup";
import SignupVercelPage from "./pages/SignupVercel";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./layouts/DashboardLayout";
import ProxyApplicationList, { ProxyApplicationListState } from './pages/ProxyApplications';
import UserList, { UserListState } from './pages/Users';
import CheckoutSuccess from './pages/CheckoutSuccess';
import NewProxyApplication from "./pages/NewProxyApplication";
import ProxyApplicationDetails from "./pages/ProxyApplicationDetails";
import ProxyApplicationLogs from "./pages/ProxyApplicationLogs";
import NewUser from "./pages/NewUser";
import Discount from "./pages/Discount";
import Profile from "./pages/Profile";
import ScrollToTop from "./components/ScrollToTop";
import GoogleAnalyticsTracker from "./components/GoogleAnalyticsTracker";
import { Profile as ProfileModel, Account as AccountModel, Region, Plan } from "./models";
import StartPasswordReset from "./pages/StartPasswordReset";
import CompletePasswordReset from "./pages/CompletePasswordReset";
import SetPassword from "./pages/SetPassword";

interface RouterProps {
  postLoginCallback: () => Promise<void>;
  authStatus: string;
  profile: ProfileModel | undefined;
  account: AccountModel | undefined;
  regions: Region[];
  plans: Plan[];
  proxyApplicationListState: ProxyApplicationListState,
  userListState: UserListState
}

const Router = (props: RouterProps) => {
  return (
    <BrowserRouter>
      <GoogleAnalyticsTracker />
      <ScrollToTop />
      <Routes>
        <Route
          path="login"
          element={<LoginPage postLoginCallback={props.postLoginCallback} />}
        />
        <Route
          path="login-vercel"
          element={<LoginVercelPage postLoginCallback={props.postLoginCallback} />}
        />
        <Route
          path="signup"
          element={<SignupPage postLoginCallback={props.postLoginCallback} />}
        />
        <Route
          path="signup-vercel"
          element={<SignupVercelPage postLoginCallback={props.postLoginCallback} />}
        />
        <Route
          path="reset-password"
          element={<StartPasswordReset />}
        />
        <Route
          path="reset-password/confirm"
          element={<CompletePasswordReset />}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute authStatus={props.authStatus}>
              <DashboardLayout profile={props.profile!} account={props.account!} />
            </ProtectedRoute>
          }
        >
          <Route index path="apps" element={<ProxyApplicationList plans={props.plans} {...props.proxyApplicationListState} />} />
          <Route path="new-app" element={<NewProxyApplication account={props.account!} regions={props.regions} plans={props.plans} />} />
          <Route path="apps/:id" element={<ProxyApplicationDetails />} />
          <Route path="apps/:id/logs" element={<ProxyApplicationLogs />} />
          <Route path="users" element={<UserList {...props.userListState} profile={props.profile!} />} />
          <Route path="discount" element={<Discount />} />
          <Route path="new-user" element={<NewUser />} />
          <Route path="checkout-success" element={<CheckoutSuccess />} />
          <Route path="profile" element={<Profile profile={props.profile!} />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/" element={<Navigate to="/apps" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
};
export default Router;
